/**
 * @param {number} listPrice
 * @param {number} discountedPrice
 * @returns {number} The discount percentage - a number between 0-100.
 */
export function getPercentOff(listPrice, discountedPrice) {
    const percentOff = Math.round(100 - (discountedPrice / listPrice) * 100);
    return listPrice < 1 || discountedPrice > listPrice || !percentOff || percentOff > 100 ? 0 : percentOff;
}

/**
 * @param {number} listPrice
 * @param {number} percentOff
 * @returns {number} The price after applying a percent off discount.
 */
export function getDiscountedPrice(listPrice, percentOff) {
    let discountedPrice;
    if (listPrice < 1) {
        discountedPrice = 0;
    } else if (percentOff < 1 || percentOff > 100) {
        discountedPrice = listPrice;
    } else {
        discountedPrice = Math.round(listPrice - listPrice * (percentOff / 100));
    }
    return discountedPrice;
}

/**
 * @param {number} num
 * @param {number} min
 * @param {number} max
 * @returns {boolean} Whether the given number is within the given range
 */
export function isNumberWithinRange(num, min, max) {
    return num >= min && num <= max;
}
